import { render, staticRenderFns } from "./DataTableServerPagination.vue?vue&type=template&id=7a6780c4"
import script from "./DataTableServerPagination.vue?vue&type=script&lang=js"
export * from "./DataTableServerPagination.vue?vue&type=script&lang=js"
import style0 from "./DataTableServerPagination.vue?vue&type=style&index=0&id=7a6780c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports